import { ChatConfig } from 'alpha-chat'

const Log = (message?: any, ...optionalParams: any[]): void => {
  if (ChatConfig.enableLog) console.log(message, ...optionalParams)
}

export default Log
